import { Box, Paper, Typography } from '@mui/material';

const CustomerConfirmationLayout = ({
	orgLogoUrl,
	orgName,
	icon,
	headline,
	children,
	footer,
}) => (
	<Box
		sx={{
			minHeight: '100vh',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			p: { xs: 2, sm: 3 },
			bgcolor: 'background.default',
		}}
	>
		<Paper
			elevation={2}
			sx={{
				p: { xs: 3, sm: 4 },
				maxWidth: 520,
				width: '100%',
				textAlign: 'center',
				borderRadius: 2,
			}}
		>
			{orgLogoUrl ? (
				<Box
					component="img"
					src={orgLogoUrl}
					alt={orgName || 'Company logo'}
					sx={{
						display: 'block',
						mx: 'auto',
						mb: 2,
						maxHeight: 56,
						maxWidth: 220,
						width: 'auto',
						height: 'auto',
					}}
				/>
			) : orgName ? (
				<Typography
					variant="h6"
					component="p"
					sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}
				>
					{orgName}
				</Typography>
			) : null}

			{icon && (
				<Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
					{icon}
				</Box>
			)}

			{headline && (
				<Typography variant="h5" component="h1" sx={{ mb: 2, fontWeight: 600 }}>
					{headline}
				</Typography>
			)}

			{children}

			{footer && (
				<Typography
					variant="caption"
					color="text.secondary"
					sx={{ display: 'block', mt: 3, opacity: 0.7 }}
				>
					{footer}
				</Typography>
			)}
		</Paper>
	</Box>
);

export default CustomerConfirmationLayout;
